import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URI } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  private baseUrl = BASE_URI.URL;

  constructor(
    private http: HttpClient
  ) { }


  getClient(payload:any) {
    const Params = this.preHttpParams(payload);

    return this.http.get(`${this.baseUrl}/getClientList`, {params: Params})
  }


  preHttpParams(payload: any) {
    let Params = new HttpParams();
    for (const key in payload) {
      if (key && (payload[key] || payload[key] === 0)) {
        Params = Params.append(key, payload[key]);
      }
    }
    return Params;
  }
}
